import i18n from "i18next";
import { initReactI18next } from "react-i18next";
const resources = {
  en: {
    translation: {
      appName: "TaweelAI",
      newChat: "New Dream",
      searchChats: "Search conversations...",
      searchHistory: "Conversations",
      profile: "Profile",
      settings: "Settings",
      logout: "Log Out",
      howCanIHelp: "What dream would you like to interpret?",
      typeMessage: "Describe your dream in detail...",
      send: "Send",
      signIn: "Sign In",
      signUp: "Create Account",
      email: "Email Address",
      password: "Password",
      confirmPassword: "Confirm Password",
      name: "Full Name",
      showPassword: "Show password",
      hidePassword: "Hide password",
      noAccount: "Don't have an account?",
      hasAccount: "Already have an account?",
      createAccount: "Create Account",
      verifyEmail: "Verify Your Email",
      resendCode: "Resend Code",
      codeSentTo: "We sent a 6-digit code to",
      checkSpam: "Check your spam folder if you don't see it.",
      orContinueWith: "or",
      continueWithGoogle: "Continue with Google",
      continueWithApple: "Continue with Apple",
      continueWithFacebook: "Continue with Facebook",
      forgotPassword: "Forgot password?",
      passwordPlaceholder: "Your password",
      namePlaceholder: "Your full name",
      confirmPasswordPlaceholder: "Repeat your password",
      signingIn: "Signing in...",
      creatingAccount: "Creating account...",
      oauthFailed: "OAuth sign-in failed. Please try again.",
      loadingApp: "Loading\u2026",
      deleted: "Deleted",
      shareLinkCopied: "Share link copied!",
      shareCompleted: "Link ready — pick an app to share",
      shareFailed: "Share failed",
      resetPasswordTitle: "Reset Password",
      setNewPassword: "Set New Password",
      newPassword: "New Password",
      min8Chars: "Min 8 characters",
      resetSuccessTitle: "Password Reset!",
      redirectingToSignIn: "Redirecting you to sign in...",
      resetPasswordBtn: "Reset Password",
      backToSignIn: "\u2190 Back to Sign In",
      minimum8CharsDot: "Minimum 8 characters.",
      linkInvalidOrExpired: "Link is invalid or expired.",
      passwordResetPleaseSignIn: "Password reset! Please sign in.",
      rename: "Rename",
      deleteChat: "Delete",
      shareChat: "Share",
      copied: "Copied to clipboard!",
      renameChat: "Rename Chat",
      newTitle: "Enter new title...",
      save: "Save",
      cancel: "Cancel",
      confirmDelete: "Delete this chat?",
      confirmDeleteMsg: "This will permanently delete this conversation. This action cannot be undone.",
      deleteForever: "Delete Forever",
      upgradePlan: "Upgrade Plan",
      notifications: "Notifications",
      notificationsTitle: "---.Notifications",
      notificationsReadAll: "Mark all read",
      notificationsRead: "Read",
      notificationsClearAll: "Clear all",
      notificationsEmpty: "No notifications yet",
      freePlan: "Free Plan",
      hourlyPlan: "Hourly Session",
      proPlan: "Pro Plan",
      messagesRemaining: "messages remaining",
      limitReached: "You have used all your free messages",
      adminUnlimited: "Unlimited messages",
      buyHour: "Buy Hours",
      unlimitedMessages: "Unlimited messages while active",
      proUnlimited: "Unlimited messages \u2014 24/7 for 30 days",
      proPlanActive: "Pro Plan Active",
      onlyOneDollar: "$1/hour",
      perHour: "/hour",
      perDay: "10 messages total",
      currentPlan: "Current Plan",
      freePlanNote: "10 messages \u2014 one time only, never resets",
      sessionActive: "Active",
      sessionExpiredTitle: "Your session has ended",
      sessionExpiredEn: "What a wonderful journey through the world of dreams! \u{1F319}\n\nI truly enjoyed our conversation together. Your session has come to its end, but the insights we uncovered are yours to keep.\n\nWhenever you're ready to explore more dreams, I'll be right here! \u2728",
      buyNewHour: "Start New Session",
      settingsTitle: "Settings",
      appearance: "Appearance",
      language: "Language",
      darkMode: "Dark Mode",
      darkModeDesc: "Switch between dark and light theme",
      languageLabel: "Interface Language",
      languageDesc: "Choose your preferred language",
      account: "Account",
      accountInfo: "Account Information",
      memberSince: "Member since",
      planStatus: "Plan Status",
      freePlanStatus: "Free \u2014 10 messages total (lifetime)",
      hourlyPlanStatus: "Active Hourly Session",
      noSessionStatus: "No active session",
      switchToLight: "Light mode",
      switchToDark: "Dark mode",
      changePassword: "Change password",
      currentPasswordLabel: "Current password",
      newPasswordLabel: "New password",
      confirmNewPasswordLabel: "Confirm new password",
      updatePassword: "Update password",
      passwordChanged: "Password updated successfully.",
      passwordChangeFailed: "Could not update password.",
      deleteAccount: "Delete account",
      deleteAccountTitle: "Delete account",
      deleteAccountDesc: "Send a deletion request to the admin. Your account stays active until the admin approves it.",
      deleteAccountConfirm: "Are you sure you want to request account deletion? Your data stays until the admin approves the request.",
      deleteAccountReasonPlaceholder: "Tell us briefly why (optional)",
      deleteAccountSubmit: "Submit deletion request",
      deleteAccountCancel: "Cancel request",
      deleteAccountPending: "Pending deletion request \u2014 awaiting admin approval.",
      deleteAccountRequested: "Deletion request submitted. The admin will review it.",
      deleteAccountCancelled: "Deletion request cancelled.",
      deleteAccountFailed: "Could not submit deletion request. Try again.",
      payNow: "Pay Now",
      paymentSuccess: "\u{1F389} Your session is now active!",
      paymentFailed: "Payment failed. Please try again.",
      loading: "Interpreting your dream...",
      error: "Something went wrong. Please try again.",
      noChats: "No conversations yet",
      today: "Today",
      inputDisclaimer: "Note: This interpretation is advisory and does not replace a qualified scholar.",
      yesterday: "Yesterday",
      termsOfUse: "Terms of Use",
      privacyPolicy: "Privacy Policy",
      welcomeTitle: "GET ACCESS",
      welcomeSub: "Interpret your dreams with the power of AI \u2014 based on Islamic & psychological sources.",
      welcome10bold: "10 Free Messages",
      welcome10label: "to get started \u2014 no credit card needed",
      welcomeDreamBold: "Dream Interpretation",
      welcomeDreamLabel: "powered by trusted Islamic & psychological sources",
      welcomePrivacyBold: "Private & Secure",
      welcomePrivacyLabel: "your dreams stay between you and Taweel",
      welcomeUpgradeBold: "Upgrade Anytime",
      welcomeUpgradeLabel: "unlock unlimited interpretations with Pro",
      welcomeFreePrice: "Free",
      welcomeFreeF1: "10 messages \u2014 one time only, never resets",
      welcomeFreeF2: "Full AI dream interpretation",
      welcomeProPrice: "Pro",
      welcomeProSub: "Unlimited \u2014 30 days",
      welcomeProF2: "Priority AI responses",
      welcomeProF3: "Cancel anytime",
      welcomeBestValue: "Best Value",
      welcomeContinueFree: "Continue with Free Plan",
      welcomeCancelAnytime: "Already have a plan? Continue \u2192",
      emailRequired: "Email is required",
      passwordRequired: "Password is required",
      nameRequired: "Name is required",
      emailInvalid: "Please enter a valid email address",
      passwordMin: "Minimum 8 characters",
      passwordUpper: "At least one uppercase letter",
      passwordNumber: "At least one number",
      passwordsMatch: "Passwords do not match",
      accountCreated: "Account activated! Please sign in.",
      adm_dashboard: "Admin Dashboard",
      adm_overview: "Overview",
      adm_users: "Users",
      adm_orders: "Orders",
      adm_deletion_requests: "Deletion Requests",
      adm_deletion_no_requests: "No pending deletion requests",
      adm_deletion_approve: "Approve & Delete",
      adm_deletion_reject: "Reject",
      adm_deletion_reason: "Reason",
      adm_deletion_requested_at: "Requested at",
      adm_deletion_approve_confirm: "Permanently delete this account? This cannot be undone.",
      adm_deletion_reject_confirm: "Reject this deletion request? The user will stay active.",
      adm_sessions: "Active Sessions",
      adm_tokens: "Token Analytics",
      adm_platform_ov: "Platform Overview",
      adm_last_7_days: "Last 7 Days",
      adm_live: "Live",
      adm_refresh: "Refresh",
      adm_total_users: "Total Users",
      adm_new_today: "New Today",
      adm_new_this_week: "New This Week",
      adm_google_oauth: "Google OAuth",
      adm_email_signups: "Email Signups",
      adm_signups_chart: "New Signups \u2014 Last 7 Days",
      adm_auth_split: "Auth Provider Split",
      adm_total_sessions: "Total Sessions",
      adm_total_messages: "Total Messages",
      adm_active_now: "Active Now",
      adm_avg_msgs_session: "Avg. Messages/Session",
      adm_daily_msgs_chart: "Daily Messages \u2014 Last 7 Days",
      adm_all_time_tokens: "All-time Tokens",
      adm_tokens_today: "Tokens Today",
      adm_est_api_cost: "Est. API Cost",
      adm_token_usage: "Token Usage",
      adm_token_consump_chart: "Token Consumption \u2014 Last 7 Days",
      adm_top_token_consumers: "Top Token Consumers",
      adm_all_time_revenue: "All-time Revenue",
      adm_this_month: "This Month",
      adm_today: "Today",
      adm_avg_order_value: "Avg. Order Value",
      adm_revenue_chart: "Revenue \u2014 Last 7 Days",
      adm_plan_dist: "Plan Distribution",
      adm_search_users: "Search name or email...",
      adm_banned: "Banned",
      adm_active: "Active",
      adm_actions: "Actions",
      adm_ban: "Ban",
      adm_unban: "Unban",
      adm_delete: "Delete",
      adm_make_admin: "Make Admin",
      adm_remove_admin: "Remove Admin",
      adm_confirm_delete_user: "Delete this user and all their chats permanently?",
      adm_time_remaining: "Time remaining",
      adm_started: "Started",
      adm_no_active_sessions: "No active sessions right now",
      adm_cost_analysis: "API consumption & cost analysis",
      adm_est_daily_cost: "Estimated Daily Cost (USD)",
      adm_est_cost: "Est. Cost",
      adm_collapse: "Collapse",
      adm_logout: "Logout",
      adm_openai: "OpenAI Usage",
      adm_provider: "Provider",
      adm_role: "Role",
      adm_status: "Status",
      adm_amount: "Amount",
      adm_currency: "Currency",
      adm_country: "Country",
      adm_date: "Date",
      adm_completed: "Completed",
      adm_total: "Total",
      adm_recent_tx: "recent transactions",
      adm_openai_budget: "Monitor actual API consumption and monthly budget",
      adm_token_sum: "Usage Summary",
      adm_daily_cost: "Daily Total Cost",
      adm_openai_analytics: "OpenAI Analytics Active",
      adm_openai_cache_note: "Usage data",
      adm_total_tokens: "Total Tokens",
      adm_recharge_credits: "Recharge Credits",
      adm_dark_mode: "Dark Mode",
      adm_light_mode: "Light Mode"
    }
  },
  ar: {
    translation: {
      appName: "\u062A\u0623\u0648\u064A\u0644 AI",
      newChat: "\u062D\u0644\u0645 \u062C\u062F\u064A\u062F",
      searchChats: "\u0627\u0628\u062D\u062B \u0641\u064A \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0627\u062A...",
      searchHistory: "\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0627\u062A",
      profile: "\u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0634\u062E\u0635\u064A",
      settings: "\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
      logout: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C",
      howCanIHelp: "\u0645\u0627 \u0647\u0648 \u062D\u0644\u0645\u0643 \u0627\u0644\u0630\u064A \u062A\u0631\u064A\u062F \u062A\u0641\u0633\u064A\u0631\u0647\u061F",
      typeMessage: "\u0635\u0641 \u062D\u0644\u0645\u0643 \u0628\u0627\u0644\u062A\u0641\u0635\u064A\u0644...",
      send: "\u0625\u0631\u0633\u0627\u0644",
      signIn: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
      signUp: "\u0625\u0646\u0634\u0627\u0621 \u062D\u0633\u0627\u0628",
      email: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
      password: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
      confirmPassword: "\u062A\u0623\u0643\u064A\u062F \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
      name: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0643\u0627\u0645\u0644",
      showPassword: "\u0625\u0638\u0647\u0627\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
      hidePassword: "\u0625\u062E\u0641\u0627\u0621 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
      noAccount: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u062D\u0633\u0627\u0628\u061F",
      hasAccount: "\u0644\u062F\u064A\u0643 \u062D\u0633\u0627\u0628 \u0628\u0627\u0644\u0641\u0639\u0644\u061F",
      createAccount: "\u0625\u0646\u0634\u0627\u0621 \u062D\u0633\u0627\u0628",
      verifyEmail: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
      resendCode: "\u0625\u0639\u0627\u062F\u0629 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u0645\u0632",
      codeSentTo: "\u0623\u0631\u0633\u0644\u0646\u0627 \u0631\u0645\u0632\u0627\u064B \u0645\u0643\u0648\u0646\u0627\u064B \u0645\u0646 6 \u0623\u0631\u0642\u0627\u0645 \u0625\u0644\u0649",
      checkSpam: "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0645\u062C\u0644\u062F \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0645\u0632\u0639\u062C \u0625\u0646 \u0644\u0645 \u062A\u062C\u062F\u0647.",
      orContinueWith: "\u0623\u0648",
      continueWithGoogle: "\u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0645\u0639 Google",
      continueWithApple: "\u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0645\u0639 Apple",
      continueWithFacebook: "\u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0645\u0639 Facebook",
      forgotPassword: "\u0647\u0644 \u0646\u0633\u064A\u062A \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631\u061F",
      passwordPlaceholder: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
      namePlaceholder: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0643\u0627\u0645\u0644",
      confirmPasswordPlaceholder: "\u0623\u0639\u062F \u0643\u062A\u0627\u0628\u0629 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
      signingIn: "\u062C\u0627\u0631\u064A \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644...",
      creatingAccount: "\u062C\u0627\u0631\u064A \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062D\u0633\u0627\u0628...",
      oauthFailed: "\u0641\u0634\u0644 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0639\u0628\u0631 Google. \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649.",
      loadingApp: "\u062C\u0627\u0631\u064A \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026",
      deleted: "\u062A\u0645 \u0627\u0644\u062D\u0630\u0641",
      shareLinkCopied: "\u062A\u0645 \u0646\u0633\u062E \u0631\u0627\u0628\u0637 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629!",
      shareCompleted: "\u0627\u0644\u0631\u0627\u0628\u0637 \u062C\u0627\u0647\u0632 \u2014 \u0627\u062E\u062A\u0631 \u062A\u0637\u0628\u064A\u0642\u064B\u0627 \u0644\u0644\u0645\u0634\u0627\u0631\u0643\u0629",
      shareFailed: "\u0641\u0634\u0644\u062A \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629",
      resetPasswordTitle: "\u0625\u0639\u0627\u062F\u0629 \u062A\u0639\u064A\u064A\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
      setNewPassword: "\u062A\u0639\u064A\u064A\u0646 \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u062C\u062F\u064A\u062F\u0629",
      newPassword: "\u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u062C\u062F\u064A\u062F\u0629",
      min8Chars: "8 \u0623\u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644",
      resetSuccessTitle: "\u062A\u0645 \u062A\u063A\u064A\u064A\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631!",
      redirectingToSignIn: "\u062C\u0627\u0631\u064A \u062A\u062D\u0648\u064A\u0644\u0643 \u0644\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644...",
      resetPasswordBtn: "\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u062A\u063A\u064A\u064A\u0631",
      backToSignIn: "\u2190 \u0627\u0644\u0631\u062C\u0648\u0639 \u0644\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
      minimum8CharsDot: "8 \u0623\u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644.",
      linkInvalidOrExpired: "\u0627\u0644\u0631\u0627\u0628\u0637 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D \u0623\u0648 \u0645\u0646\u062A\u0647\u064A.",
      passwordResetPleaseSignIn: "\u062A\u0645 \u062A\u063A\u064A\u064A\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631! \u0633\u062C\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0627\u0644\u0622\u0646.",
      rename: "\u0625\u0639\u0627\u062F\u0629 \u062A\u0633\u0645\u064A\u0629",
      deleteChat: "\u062D\u0630\u0641",
      shareChat: "\u0645\u0634\u0627\u0631\u0643\u0629",
      copied: "\u062A\u0645 \u0627\u0644\u0646\u0633\u062E!",
      renameChat: "\u0625\u0639\u0627\u062F\u0629 \u062A\u0633\u0645\u064A\u0629 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629",
      newTitle: "\u0623\u062F\u062E\u0644 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u062C\u062F\u064A\u062F...",
      save: "\u062D\u0641\u0638",
      cancel: "\u0625\u0644\u063A\u0627\u0621",
      confirmDelete: "\u062D\u0630\u0641 \u0647\u0630\u0647 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629\u061F",
      confirmDeleteMsg: "\u0633\u064A\u0624\u062F\u064A \u0647\u0630\u0627 \u0625\u0644\u0649 \u062D\u0630\u0641 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629 \u0646\u0647\u0627\u0626\u064A\u0627\u064B \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621.",
      deleteForever: "\u062D\u0630\u0641 \u0646\u0647\u0627\u0626\u064A",
      upgradePlan: "\u062A\u0631\u0642\u064A\u0629 \u0627\u0644\u062E\u0637\u0629",
      notifications: "\u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A",
      notificationsTitle: "----.\u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A",
      notificationsReadAll: "\u0642\u0631\u0627\u0621\u0629 \u0627\u0644\u0643\u0644",
      notificationsRead: "\u0642\u0631\u0627\u0621\u0629",
      notificationsClearAll: "\u0645\u0633\u062D \u0627\u0644\u0643\u0644",
      notificationsEmpty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0625\u0634\u0639\u0627\u0631\u0627\u062A",
      freePlan: "\u0627\u0644\u062E\u0637\u0629 \u0627\u0644\u0645\u062C\u0627\u0646\u064A\u0629",
      hourlyPlan: "\u062C\u0644\u0633\u0629 \u0628\u0627\u0644\u0633\u0627\u0639\u0629",
      proPlan: "\u0628\u0627\u0642\u0629 Pro",
      messagesRemaining: "\u0631\u0633\u0627\u0626\u0644 \u0645\u062A\u0628\u0642\u064A\u0629",
      limitReached: "\u0644\u0642\u062F \u0627\u0633\u062A\u062E\u062F\u0645\u062A \u062C\u0645\u064A\u0639 \u0631\u0633\u0627\u0626\u0644\u0643 \u0627\u0644\u0645\u062C\u0627\u0646\u064A\u0629",
      adminUnlimited: "\u0631\u0633\u0627\u0626\u0644 \u063A\u064A\u0631 \u0645\u062D\u062F\u0648\u062F\u0629",
      buyHour: "\u0634\u0631\u0627\u0621 \u0633\u0627\u0639\u0627\u062A",
      unlimitedMessages: "\u0631\u0633\u0627\u0626\u0644 \u063A\u064A\u0631 \u0645\u062D\u062F\u0648\u062F\u0629 \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0629",
      proUnlimited: "\u0631\u0633\u0627\u0626\u0644 \u063A\u064A\u0631 \u0645\u062D\u062F\u0648\u062F\u0629 \u2014 24/7 \u0644\u0645\u062F\u0629 30 \u064A\u0648\u0645",
      proPlanActive: "\u0628\u0627\u0642\u0629 Pro \u0646\u0634\u0637\u0629",
      onlyOneDollar: "\u062F\u0648\u0644\u0627\u0631/\u0633\u0627\u0639\u0629",
      perHour: "/\u0633\u0627\u0639\u0629",
      perDay: "10 \u0631\u0633\u0627\u0626\u0644 \u0625\u062C\u0645\u0627\u0644\u064A\u0629",
      currentPlan: "\u0627\u0644\u062E\u0637\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629",
      freePlanNote: "10 \u0631\u0633\u0627\u0626\u0644 \u2014 \u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0641\u0642\u0637\u060C \u0644\u0627 \u062A\u062A\u062C\u062F\u062F \u0623\u0628\u062F\u064B\u0627",
      sessionActive: "\u0646\u0634\u0637\u0629",
      sessionExpiredTitle: "\u0627\u0646\u062A\u0647\u062A \u062C\u0644\u0633\u062A\u0643",
      sessionExpiredAr: "\u064A\u0627 \u0635\u062F\u064A\u0642\u064A \u0627\u0644\u062D\u0628\u064A\u0628\u060C \u0643\u0627\u0646\u062A \u0631\u062D\u0644\u062A\u0646\u0627 \u0641\u064A \u0639\u0627\u0644\u0645 \u0627\u0644\u0623\u062D\u0644\u0627\u0645 \u0631\u0627\u0626\u0639\u0629 \u062D\u0642\u0627\u064B! \u{1F319}\n\n\u0627\u0633\u062A\u0645\u062A\u0639\u062A \u0643\u062B\u064A\u0631\u0627\u064B \u0628\u062D\u062F\u064A\u062B\u0646\u0627\u060C \u0648\u0623\u062A\u0645\u0646\u0649 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0627\u0644\u062A\u0641\u0633\u064A\u0631\u0627\u062A \u0642\u062F \u0623\u0636\u0627\u0621\u062A \u0644\u0643 \u0627\u0644\u0637\u0631\u064A\u0642 \u0648\u0623\u062C\u0627\u0628\u062A \u0639\u0646 \u062A\u0633\u0627\u0624\u0644\u0627\u062A\u0643.\n\n\u0639\u0646\u062F\u0645\u0627 \u062A\u0643\u0648\u0646 \u0645\u0633\u062A\u0639\u062F\u0627\u064B \u0644\u0627\u0633\u062A\u0643\u0634\u0627\u0641 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0623\u0633\u0631\u0627\u0631 \u0627\u0644\u0623\u062D\u0644\u0627\u0645\u060C \u0633\u0623\u0643\u0648\u0646 \u0647\u0646\u0627 \u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631\u0643! \u2728\u{1F49A}",
      buyNewHour: "\u0627\u0628\u062F\u0623 \u062C\u0644\u0633\u0629 \u062C\u062F\u064A\u062F\u0629",
      settingsTitle: "\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
      appearance: "\u0627\u0644\u0645\u0638\u0647\u0631",
      language: "\u0627\u0644\u0644\u063A\u0629",
      darkMode: "\u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u062F\u0627\u0643\u0646",
      darkModeDesc: "\u0627\u0644\u062A\u0628\u062F\u064A\u0644 \u0628\u064A\u0646 \u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u062F\u0627\u0643\u0646 \u0648\u0627\u0644\u0641\u0627\u062A\u062D",
      languageLabel: "\u0644\u063A\u0629 \u0627\u0644\u0648\u0627\u062C\u0647\u0629",
      languageDesc: "\u0627\u062E\u062A\u0631 \u0644\u063A\u062A\u0643 \u0627\u0644\u0645\u0641\u0636\u0644\u0629",
      account: "\u0627\u0644\u062D\u0633\u0627\u0628",
      accountInfo: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u062D\u0633\u0627\u0628",
      memberSince: "\u0639\u0636\u0648 \u0645\u0646\u0630",
      planStatus: "\u062D\u0627\u0644\u0629 \u0627\u0644\u062E\u0637\u0629",
      freePlanStatus: "\u0645\u062C\u0627\u0646\u064A\u0629 \u2014 10 \u0631\u0633\u0627\u0626\u0644 \u0641\u0642\u0637 (\u0645\u062F\u0649 \u0627\u0644\u062D\u064A\u0627\u0629)",
      hourlyPlanStatus: "\u062C\u0644\u0633\u0629 \u0633\u0627\u0639\u0629 \u0646\u0634\u0637\u0629",
      noSessionStatus: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062C\u0644\u0633\u0629 \u0646\u0634\u0637\u0629",
      switchToLight: "\u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0641\u0627\u062A\u062D",
      switchToDark: "\u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u062F\u0627\u0643\u0646",
      changePassword: "\u062A\u063A\u064A\u064A\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
      currentPasswordLabel: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062D\u0627\u0644\u064A\u0629",
      newPasswordLabel: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062C\u062F\u064A\u062F\u0629",
      confirmNewPasswordLabel: "\u062A\u0623\u0643\u064A\u062F \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062C\u062F\u064A\u062F\u0629",
      updatePassword: "\u062A\u062D\u062F\u064A\u062B \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
      passwordChanged: "\u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0628\u0646\u062C\u0627\u062D.",
      passwordChangeFailed: "\u062A\u0639\u0630\u0631 \u062A\u062D\u062F\u064A\u062B \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631.",
      deleteAccount: "\u062D\u0630\u0641 \u0627\u0644\u062D\u0633\u0627\u0628",
      deleteAccountTitle: "\u062D\u0630\u0641 \u0627\u0644\u062D\u0633\u0627\u0628",
      deleteAccountDesc: "\u0625\u0631\u0633\u0627\u0644 \u0637\u0644\u0628 \u062D\u0630\u0641 \u0644\u0644\u0623\u062F\u0645\u0646. \u064A\u0628\u0642\u0649 \u062D\u0633\u0627\u0628\u0643 \u0641\u0639\u0627\u0644\u0627\u064B \u062D\u062A\u0649 \u064A\u0648\u0627\u0641\u0642 \u0627\u0644\u0623\u062F\u0645\u0646 \u0639\u0644\u0649 \u0627\u0644\u0637\u0644\u0628.",
      deleteAccountConfirm: "\u0647\u0644 \u0623\u0646\u062A \u0645\u062A\u0623\u0643\u062F \u0645\u0646 \u0637\u0644\u0628 \u062D\u0630\u0641 \u0627\u0644\u062D\u0633\u0627\u0628\u061F \u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u062A\u0628\u0642\u0649 \u0644\u062D\u064A\u0646 \u0645\u0648\u0627\u0641\u0642\u0629 \u0627\u0644\u0623\u062F\u0645\u0646.",
      deleteAccountReasonPlaceholder: "\u0627\u0644\u0633\u0628\u0628 \u0628\u0627\u062E\u062A\u0635\u0627\u0631 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
      deleteAccountSubmit: "\u0625\u0631\u0633\u0627\u0644 \u0637\u0644\u0628 \u0627\u0644\u062D\u0630\u0641",
      deleteAccountCancel: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0637\u0644\u0628",
      deleteAccountPending: "\u0637\u0644\u0628 \u062D\u0630\u0641 \u0642\u064A\u062F \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629 \u2014 \u0628\u0627\u0646\u062A\u0638\u0627\u0631 \u0645\u0648\u0627\u0641\u0642\u0629 \u0627\u0644\u0623\u062F\u0645\u0646.",
      deleteAccountRequested: "\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0637\u0644\u0628 \u0627\u0644\u062D\u0630\u0641. \u0633\u064A\u0631\u0627\u062C\u0639\u0647 \u0627\u0644\u0623\u062F\u0645\u0646.",
      deleteAccountCancelled: "\u062A\u0645 \u0625\u0644\u063A\u0627\u0621 \u0637\u0644\u0628 \u0627\u0644\u062D\u0630\u0641.",
      deleteAccountFailed: "\u062A\u0639\u0630\u0631 \u0625\u0631\u0633\u0627\u0644 \u0637\u0644\u0628 \u0627\u0644\u062D\u0630\u0641. \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649.",
      payNow: "\u0627\u062F\u0641\u0639 \u0627\u0644\u0622\u0646",
      paymentSuccess: "\u{1F389} \u062C\u0644\u0633\u062A\u0643 \u0646\u0634\u0637\u0629 \u0627\u0644\u0622\u0646!",
      paymentFailed: "\u0641\u0634\u0644 \u0627\u0644\u062F\u0641\u0639. \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649.",
      loading: "\u062C\u0627\u0631\u064A \u062A\u0641\u0633\u064A\u0631 \u062D\u0644\u0645\u0643...",
      error: "\u062D\u062F\u062B \u062E\u0637\u0623. \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649.",
      noChats: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u062D\u0627\u062F\u062B\u0627\u062A \u0628\u0639\u062F",
      today: "\u0627\u0644\u064A\u0648\u0645",
      inputDisclaimer: "\u062A\u0646\u0648\u064A\u0647: \u0647\u0630\u0627 \u0627\u0644\u062A\u0641\u0633\u064A\u0631 \u0627\u0633\u062A\u0634\u0627\u0631\u064A \u0648\u0644\u0627 \u064A\u063A\u0646\u064A \u0639\u0646 \u0627\u0644\u0631\u062C\u0648\u0639 \u0625\u0644\u0649 \u0639\u0627\u0644\u0645 \u0645\u062A\u062E\u0635\u0635 \u0641\u064A \u0627\u0644\u062A\u0641\u0633\u064A\u0631.",
      yesterday: "\u0623\u0645\u0633",
      termsOfUse: "\u0634\u0631\u0648\u0637 \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645",
      privacyPolicy: "\u0633\u064A\u0627\u0633\u0629 \u0627\u0644\u062E\u0635\u0648\u0635\u064A\u0629",
      welcomeTitle: "\u0627\u062D\u0635\u0644 \u0639\u0644\u0649 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u062F\u062E\u0648\u0644",
      welcomeSub: "\u0641\u0633\u0651\u0631 \u0623\u062D\u0644\u0627\u0645\u0643 \u0628\u0642\u0648\u0629 \u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064A \u2014 \u0628\u0646\u0627\u0621\u064B \u0639\u0644\u0649 \u0645\u0635\u0627\u062F\u0631 \u0625\u0633\u0644\u0627\u0645\u064A\u0629 \u0648\u0646\u0641\u0633\u064A\u0629 \u0645\u0648\u062B\u0648\u0642\u0629.",
      welcome10bold: "10 \u0631\u0633\u0627\u0626\u0644 \u0645\u062C\u0627\u0646\u064A\u0629",
      welcome10label: "\u0644\u0644\u0628\u062F\u0621 \u2014 \u0644\u0627 \u064A\u0644\u0632\u0645 \u0628\u0637\u0627\u0642\u0629 \u0627\u0626\u062A\u0645\u0627\u0646\u064A\u0629",
      welcomeDreamBold: "\u062A\u0641\u0633\u064A\u0631 \u0627\u0644\u0623\u062D\u0644\u0627\u0645",
      welcomeDreamLabel: "\u0645\u062F\u0639\u0648\u0645 \u0628\u0645\u0635\u0627\u062F\u0631 \u0625\u0633\u0644\u0627\u0645\u064A\u0629 \u0648\u0646\u0641\u0633\u064A\u0629 \u0645\u0648\u062B\u0648\u0642\u0629",
      welcomePrivacyBold: "\u062E\u0635\u0648\u0635\u064A\u0629 \u0648\u0623\u0645\u0627\u0646",
      welcomePrivacyLabel: "\u0623\u062D\u0644\u0627\u0645\u0643 \u062A\u0628\u0642\u0649 \u0628\u064A\u0646\u0643 \u0648\u0628\u064A\u0646 \u062A\u0623\u0648\u064A\u0644",
      welcomeUpgradeBold: "\u062A\u0631\u0642\u064A\u0629 \u0641\u064A \u0623\u064A \u0648\u0642\u062A",
      welcomeUpgradeLabel: "\u0627\u062D\u0635\u0644 \u0639\u0644\u0649 \u062A\u0641\u0633\u064A\u0631\u0627\u062A \u063A\u064A\u0631 \u0645\u062D\u062F\u0648\u062F\u0629 \u0645\u0639 Pro",
      welcomeFreePrice: "\u0645\u062C\u0627\u0646\u064B\u0627",
      welcomeFreeF1: "10 \u0631\u0633\u0627\u0626\u0644 \u2014 \u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0641\u0642\u0637\u060C \u0644\u0627 \u062A\u062A\u062C\u062F\u062F \u0623\u0628\u062F\u064B\u0627",
      welcomeFreeF2: "\u062A\u0641\u0633\u064A\u0631 \u0623\u062D\u0644\u0627\u0645 \u0643\u0627\u0645\u0644 \u0628\u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064A",
      welcomeProPrice: "Pro",
      welcomeProSub: "\u063A\u064A\u0631 \u0645\u062D\u062F\u0648\u062F \u2014 30 \u064A\u0648\u0645\u064B\u0627",
      welcomeProF2: "\u0631\u062F\u0648\u062F \u0630\u0643\u0627\u0621 \u0627\u0635\u0637\u0646\u0627\u0639\u064A \u0630\u0627\u062A \u0623\u0648\u0644\u0648\u064A\u0629",
      welcomeProF3: "\u0625\u0644\u063A\u0627\u0621 \u0641\u064A \u0623\u064A \u0648\u0642\u062A",
      welcomeBestValue: "\u0627\u0644\u0623\u0641\u0636\u0644 \u0642\u064A\u0645\u0629",
      welcomeContinueFree: "\u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0628\u0627\u0644\u062E\u0637\u0629 \u0627\u0644\u0645\u062C\u0627\u0646\u064A\u0629",
      welcomeCancelAnytime: "\u0644\u062F\u064A\u0643 \u062E\u0637\u0629 \u0628\u0627\u0644\u0641\u0639\u0644\u061F \u062A\u0627\u0628\u0639 \u2190",
      emailRequired: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0645\u0637\u0644\u0648\u0628",
      passwordRequired: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0645\u0637\u0644\u0648\u0628\u0629",
      nameRequired: "\u0627\u0644\u0627\u0633\u0645 \u0645\u0637\u0644\u0648\u0628",
      emailInvalid: "\u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
      passwordMin: "8 \u0623\u062D\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644",
      passwordUpper: "\u062D\u0631\u0641 \u0643\u0628\u064A\u0631 \u0648\u0627\u062D\u062F \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644",
      passwordNumber: "\u0631\u0642\u0645 \u0648\u0627\u062D\u062F \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644",
      passwordsMatch: "\u0643\u0644\u0645\u062A\u0627 \u0627\u0644\u0645\u0631\u0648\u0631 \u063A\u064A\u0631 \u0645\u062A\u0637\u0627\u0628\u0642\u062A\u064A\u0646",
      accountCreated: "\u062A\u0645 \u062A\u0641\u0639\u064A\u0644 \u0627\u0644\u062D\u0633\u0627\u0628! \u064A\u0631\u062C\u0649 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644.",
      adm_dashboard: "\u0644\u0648\u062D\u0629 \u0627\u0644\u062A\u062D\u0643\u0645",
      adm_overview: "\u0646\u0638\u0631\u0629 \u0639\u0627\u0645\u0629",
      adm_users: "\u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646",
      adm_orders: "\u0627\u0644\u0637\u0644\u0628\u0627\u062A",
      adm_deletion_requests: "\u0637\u0644\u0628\u0627\u062A \u062D\u0630\u0641 \u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A",
      adm_deletion_no_requests: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0637\u0644\u0628\u0627\u062A \u062D\u0630\u0641 \u062D\u0627\u0644\u064A\u0627\u064B",
      adm_deletion_approve: "\u0645\u0648\u0627\u0641\u0642\u0629 \u0648\u062D\u0630\u0641",
      adm_deletion_reject: "\u0631\u0641\u0636",
      adm_deletion_reason: "\u0627\u0644\u0633\u0628\u0628",
      adm_deletion_requested_at: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0637\u0644\u0628",
      adm_deletion_approve_confirm: "\u062D\u0630\u0641 \u0647\u0630\u0627 \u0627\u0644\u062D\u0633\u0627\u0628 \u0646\u0647\u0627\u0626\u064A\u0627\u064B\u061F \u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u062A\u0631\u0627\u062C\u0639.",
      adm_deletion_reject_confirm: "\u0631\u0641\u0636 \u0637\u0644\u0628 \u062D\u0630\u0641 \u0647\u0630\u0627 \u0627\u0644\u062D\u0633\u0627\u0628\u061F \u0633\u064A\u0628\u0642\u0649 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0646\u0634\u0637\u0627\u064B.",
      adm_sessions: "\u0627\u0644\u062C\u0644\u0633\u0627\u062A \u0627\u0644\u0646\u0634\u0637\u0629",
      adm_tokens: "\u062A\u062D\u0644\u064A\u0644\u0627\u062A \u0627\u0644\u062A\u0648\u0643\u0646\u0632",
      adm_platform_ov: "\u0646\u0638\u0631\u0629 \u0639\u0627\u0645\u0629 \u0639\u0644\u0649 \u0627\u0644\u0645\u0646\u0635\u0629",
      adm_last_7_days: "\u0622\u062E\u0631 7 \u0623\u064A\u0627\u0645",
      adm_live: "\u0645\u0628\u0627\u0634\u0631",
      adm_refresh: "\u062A\u062D\u062F\u064A\u062B",
      adm_total_users: "\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646",
      adm_new_today: "\u062C\u062F\u062F \u0627\u0644\u064A\u0648\u0645",
      adm_new_this_week: "\u062C\u062F\u062F \u0647\u0630\u0627 \u0627\u0644\u0623\u0633\u0628\u0648\u0639",
      adm_google_oauth: "\u062C\u0648\u062C\u0644",
      adm_email_signups: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
      adm_signups_chart: "\u0627\u0644\u062A\u0633\u062C\u064A\u0644\u0627\u062A \u0627\u0644\u062C\u062F\u064A\u062F\u0629 \u2014 \u0622\u062E\u0631 7 \u0623\u064A\u0627\u0645",
      adm_auth_split: "\u062A\u0648\u0632\u064A\u0639 \u0637\u0631\u0642 \u0627\u0644\u062A\u0633\u062C\u064A\u0644",
      adm_total_sessions: "\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u062C\u0644\u0633\u0627\u062A",
      adm_total_messages: "\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0631\u0633\u0627\u0626\u0644",
      adm_active_now: "\u0646\u0634\u0637 \u0627\u0644\u0622\u0646",
      adm_avg_msgs_session: "\u0645\u062A\u0648\u0633\u0637 \u0627\u0644\u0631\u0633\u0627\u0626\u0644/\u0627\u0644\u062C\u0644\u0633\u0629",
      adm_daily_msgs_chart: "\u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u064A\u0648\u0645\u064A\u0629 \u2014 \u0622\u062E\u0631 7 \u0623\u064A\u0627\u0645",
      adm_all_time_tokens: "\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u062A\u0648\u0643\u0646\u0632",
      adm_tokens_today: "\u062A\u0648\u0643\u0646\u0632 \u0627\u0644\u064A\u0648\u0645",
      adm_est_api_cost: "\u0627\u0644\u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u062A\u0642\u062F\u064A\u0631\u064A\u0629 (API)",
      adm_token_usage: "\u0627\u0633\u062A\u0647\u0644\u0627\u0643 \u0627\u0644\u062A\u0648\u0643\u0646\u0632",
      adm_token_consump_chart: "\u0627\u0633\u062A\u0647\u0644\u0627\u0643 \u0627\u0644\u062A\u0648\u0643\u0646\u0632 \u2014 \u0622\u062E\u0631 7 \u0623\u064A\u0627\u0645",
      adm_top_token_consumers: "\u0627\u0644\u0623\u0643\u062B\u0631 \u0627\u0633\u062A\u0647\u0644\u0627\u0643\u0627\u064B \u0644\u0644\u062A\u0648\u0643\u0646\u0632",
      adm_all_time_revenue: "\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0625\u064A\u0631\u0627\u062F\u0627\u062A",
      adm_this_month: "\u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631",
      adm_today: "\u0627\u0644\u064A\u0648\u0645",
      adm_avg_order_value: "\u0645\u062A\u0648\u0633\u0637 \u0642\u064A\u0645\u0629 \u0627\u0644\u0637\u0644\u0628",
      adm_revenue_chart: "\u0627\u0644\u0625\u064A\u0631\u0627\u062F\u0627\u062A \u2014 \u0622\u062E\u0631 7 \u0623\u064A\u0627\u0645",
      adm_plan_dist: "\u062A\u0648\u0632\u064A\u0639 \u0627\u0644\u062E\u0637\u0637",
      adm_search_users: "\u0627\u0628\u062D\u062B \u0639\u0646 \u0627\u0633\u0645 \u0623\u0648 \u0628\u0631\u064A\u062F...",
      adm_banned: "\u0645\u062D\u0638\u0648\u0631",
      adm_active: "\u0646\u0634\u0637",
      adm_actions: "\u0625\u062C\u0631\u0627\u0621\u0627\u062A",
      adm_ban: "\u062D\u0638\u0631",
      adm_unban: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u062D\u0638\u0631",
      adm_delete: "\u062D\u0630\u0641",
      adm_make_admin: "\u062A\u0639\u064A\u064A\u0646 \u0623\u062F\u0645\u0646",
      adm_remove_admin: "\u0625\u0632\u0627\u0644\u0629 \u0623\u062F\u0645\u0646",
      adm_confirm_delete_user: "\u0647\u0644 \u062A\u0631\u064A\u062F \u062D\u0630\u0641 \u0647\u0630\u0627 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0648\u062C\u0645\u064A\u0639 \u0645\u062D\u0627\u062F\u062B\u0627\u062A\u0647 \u0646\u0647\u0627\u0626\u064A\u0627\u064B\u061F",
      adm_time_remaining: "\u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u062A\u0628\u0642\u064A",
      adm_started: "\u0628\u062F\u0623\u062A \u0641\u064A",
      adm_no_active_sessions: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062C\u0644\u0633\u0627\u062A \u0646\u0634\u0637\u0629 \u062D\u0627\u0644\u064A\u0627\u064B",
      adm_cost_analysis: "\u062A\u062D\u0644\u064A\u0644 \u062A\u0643\u0644\u0641\u0629 \u0648\u0627\u0633\u062A\u0647\u0644\u0627\u0643 API",
      adm_est_daily_cost: "\u0627\u0644\u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u064A\u0648\u0645\u064A\u0629 \u0627\u0644\u062A\u0642\u062F\u064A\u0631\u064A\u0629 (USD)",
      adm_est_cost: "\u0627\u0644\u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u062A\u0642\u062F\u064A\u0631\u064A\u0629",
      adm_collapse: "\u062A\u0635\u063A\u064A\u0631",
      adm_logout: "\u062E\u0631\u0648\u062C",
      adm_openai: "\u0627\u0633\u062A\u0647\u0644\u0627\u0643 OpenAI",
      adm_provider: "\u0627\u0644\u0645\u0632\u0648\u062F",
      adm_role: "\u0627\u0644\u062F\u0648\u0631",
      adm_status: "\u0627\u0644\u062D\u0627\u0644\u0629",
      adm_amount: "\u0627\u0644\u0645\u0628\u0644\u063A",
      adm_currency: "\u0627\u0644\u0639\u0645\u0644\u0629",
      adm_country: "\u0627\u0644\u062F\u0648\u0644\u0629",
      adm_date: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E",
      adm_completed: "\u0645\u0643\u062A\u0645\u0644",
      adm_total: "\u0625\u062C\u0645\u0627\u0644\u064A",
      adm_recent_tx: "\u0639\u0645\u0644\u064A\u0627\u062A \u062D\u062F\u064A\u062B\u0629",
      adm_openai_budget: "\u0645\u0631\u0627\u0642\u0628\u0629 \u0627\u0644\u0627\u0633\u062A\u0647\u0644\u0627\u0643 \u0627\u0644\u0641\u0639\u0644\u064A \u0648\u0627\u0644\u0645\u064A\u0632\u0627\u0646\u064A\u0629",
      adm_token_sum: "\u0645\u0644\u062E\u0635 \u0627\u0644\u0627\u0633\u062A\u0647\u0644\u0627\u0643",
      adm_daily_cost: "\u0627\u0644\u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0625\u062C\u0645\u0627\u0644\u064A\u0629 \u0627\u0644\u064A\u0648\u0645",
      adm_openai_analytics: "\u062A\u062D\u0644\u064A\u0644\u0627\u062A OpenAI",
      adm_openai_cache_note: "\u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645",
      adm_total_tokens: "\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u062A\u0648\u0643\u0646\u0632",
      adm_recharge_credits: "\u0634\u062D\u0646 \u0627\u0644\u0631\u0635\u064A\u062F",
      adm_dark_mode: "\u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0644\u064A\u0644\u064A",
      adm_light_mode: "\u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0646\u0647\u0627\u0631\u064A"
    }
  }
};
i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("taweelai_lang") || "ar",
  fallbackLng: "en",
  interpolation: { escapeValue: false }
});
(function() {
  const lang = localStorage.getItem("taweelai_lang") || "ar";
  document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  document.documentElement.lang = lang;
  if (!localStorage.getItem("taweelai_lang")) {
    localStorage.setItem("taweelai_lang", "ar");
  }
})();
var stdin_default = i18n;
export {
  stdin_default as default
};
